<template>
  <div class="example">
    <div class="top">
      <div>
        <one v-if="people === 1"/>
        <family v-else-if="people === 2"/>
        <family-kids v-else-if="people === 4"/>
        <family-kids-large v-else/>
      </div>
      {{ label }}
    </div>
    <div v-if="lines_data.length" class="bottom">

      <template v-for="(line, index) in key, lines_data">
        <div v-bind:key="index">{{ line[0] }}</div>
        <div v-bind:key="index">{{ line[1] }}</div>
      </template>


      <!--<div>Due diligence Fee</div>
      <div >{{lines_data[1]}}</div>

      <div>Application fee</div>
      <div >{{lines_data[2]}}</div>

      <div>Professional Fees</div>
      <div>{{lines_data[3]}}</div>

      <div>Processing fee</div>
      <div >{{lines_data[4]}}</div>

      <div>In total</div>
      <div >{{lines_data[5]}}</div>-->
    </div>
  </div>
</template>

<script>
import One from '@/assets/family/one.svg';
import Family from '@/assets/family/family.svg';
import FamilyKids from '@/assets/family/family-kids.svg';
import FamilyKidsLarge from '@/assets/family/family-kids-large.svg';

export default {
  components: { One, Family, FamilyKids, FamilyKidsLarge },
  props: {
    label: { type: String, default: '' },
    people: { type: Number, default: 1, },
      lines_data: {type: Array}
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.example {
  border-radius: 6px;
  background: #eff8fe;
  max-width: 360px;
  box-shadow: -5px 20px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  font-size: 14px;
  margin: 0 30px 40px;

  @include desktop {
    margin: 0 30px 50px;
  }

  &:hover {
    background: #3486ac;

    .top {
      color: #fff;

      ::v-deep path {
        fill: #fff !important;
      }
    }
  }
}

.top {
  padding: 20px;
  text-align: center;
  transition: all 0.3s;

  path {
    transition: all 0.3s;
  }
}

.bottom {
  background: #fff;
  border-radius: 6px;
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-between;
  grid-gap: 10px;
  color: #131e43;

  @include mobile {
    padding: 30px 20px;
  }

  @include desktop {
    padding: 30px;
  }

  & > * {
    &:nth-child(even) {
      font-weight: 700;
    }
  }
}
</style>